import React, {FC, ReactElement} from 'react';
import './Set.scss';
import styled from 'styled-components';
import Group from '../group/Group';

interface MainState {

}

export type SetProps = {
    index:number|null,
    path: {
        slideIndex:number,
        comboIndex:number,
        setIndex: number,
        groupIndex: number,
        elementIndex: number|null,
        subElementIndex: number|null
    }|null,
    activePath:{
        slideIndex:number,
        comboIndex:number|null,
        setIndex: number|null,
        groupIndex: number|null,
        elementIndex: number|null,
    } | null,
    selectActive:Function|null,
    horizontalAlignment: string,
    verticalAlignment: string,
    isGroupRatioSet:boolean,
    groupsRatio: [string, string],
    groups: any,
    editorPlugins: any|null,
    isAddElement: boolean|null,
    isEmptySlide: boolean|null,
    backgroundColor: string,
    borderColor: string,
    borderWidth: number,
    round: string,
    isTab:boolean
    activeTab:number
    isActiveNarrator:boolean|null,
    anchorName:string,
    isAnchorActive:boolean
    organizeGroupsForMobile:boolean|null,
    disableDND:boolean,
    label?: string
}

type SetDesignedProps = {
    groupsRatio: [string, string],
    verticalAlignment: string,
    horizontalAlignment: string,
    backgroundColor: string,
    borderColor: string,
    borderWidth: number,
    borderRadius: string,
}


export const SetDesigned = styled.div<SetDesignedProps>`
    &.set {
        flex-flow: ${props => props.groupsRatio[0] === '100' ? 'column':'row'};
        justify-content: ${props => props.horizontalAlignment}; 
        align-items: ${props => props.verticalAlignment};
        align-self: ${props => props.verticalAlignment};
        ${props => props.horizontalAlignment === 'start' &&`
            text-align:left;
        `}; 
        ${props => props.horizontalAlignment === 'center' &&`
            text-align:center;
        `}; 
         ${props => props.horizontalAlignment === 'end' &&`
            text-align:right;
        `}; 
        .setInnerWrapper {
            background: ${props => props.backgroundColor || 'none'};
            ${props => props.borderWidth > 0 &&`
                border: ${props.borderWidth}px solid ${props.borderColor || 'transparent'};
            `}; 
             border-radius: ${props => props.borderRadius ? props.borderRadius : '0'};
             .emptyGroup.pos-0 {
                width: ${props => props.groupsRatio[0] + '%'};
             }
             .emptyGroup.pos-1 {
                width: ${props => props.groupsRatio[1] + '%'};
             }
         }
    }
`;

const Set:FC<SetProps> = ({...props}) : ReactElement => {

    const isEditor = props.editorPlugins;

    function checkForMainMediaInMobile(groupData:any) {
        if(groupData.length !== 1) return 1;
        if(groupData[0].name === 'Image' || groupData[0].name === 'Video' || groupData[0].name === 'Charts') return 0;
        return 1;
    }

    function setOptions() {
        return props.label === 'Side by side'
            ? [...options, ...sideBySideLayout]
            : options
    }

    if(isEditor) {
        const SetEditor = require('./SetEditor').default
        return <SetEditor {...props} setSettings={settings} options={setOptions()} />;
    }
    else {
        return (<SetDesigned className={"set " + (props.isTab ? 'tab ' : '') + (props.activeTab ? 'activeTab ':'') + (props.isActiveNarrator ? 'activeNarrator': '')}
                             groupsRatio={props.groupsRatio} horizontalAlignment={props.horizontalAlignment} verticalAlignment={props.verticalAlignment}
                             borderRadius={props.round} borderWidth={props.borderWidth} borderColor={props.borderColor} backgroundColor={props.backgroundColor}
                             data-anchor-target={props.isAnchorActive ? props.anchorName : ''}>
            <div className="setInnerWrapper">
                {
                    props.groups && props.groups.map((groupData: any, index: number) => {
                        let order = null;
                        if(window.innerWidth < 768) order = checkForMainMediaInMobile(groupData);
                        return <Group key={index} elements={groupData} width={props.groupsRatio[index]} editorPlugins={null} index={index} path={null} mobileOrder={order}/>;
                    })
                }
            </div>
        </SetDesigned>);
    }
}

export default Set;

export let settings:any[];
let SettingsData;
const environmentLink:any = window.getEnvironmentLink()
try {
    SettingsData = require('../../settings-data').default;
    // do stuff
} catch (ex) {
    SettingsData = null;
}
if(SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            },
            {
                settingName: 'VerticalAlignment',
            },
            {
                settingName: 'BackgroundColor',
                controls: [
                    {
                        controlName: 'CustomColors',
                        property: 'backgroundColor',
                        title: '',
                        defaultValue: '#fff',
                    },
                ],
            },
            {
                settingName: 'BorderColor',
                isShowTitle: false,
                controls: [
                    {
                        controlName: 'CustomColorsTabs',
                        title: '',
                        defaultValue: '#fff',
                        isGradient: false,
                        tabs: [
                            {
                                name: 'default',
                                title:'Default',
                                property: 'borderColor',
                            },
                            {
                                name: 'hover',
                                title:'Hover',
                                property: 'borderColorHover',
                            }
                        ]
                    },
                ],
            },
            {
                settingName: 'BorderWidth',
            },
            {
                settingName: 'BorderRadius',
            },
            {
                settingName: 'ContainerRatio',
                enable: {
                    type: 'combo',
                    values: ['SideBySide', 'Tabs']
                }
            },
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];
}

const options = [
    {
        name: 'horizontalAlignment',
        title: 'Align',
        icon: environmentLink + '/assets/images/Options/align.svg',
        action: 'setActiveSetting',
        settingTitle: 'Horizontal Alignment',
    },
    {
        name: 'backgroundColor',
        title: 'Background',
        icon: environmentLink + '/assets/images/Options/color.svg',
        action: 'setActiveSetting',
        settingTitle: 'Background Color',
    }
]

const sideBySideLayout = [
    {
        name: 'groupsRation',
        title: 'Layout',
        icon: environmentLink + '/assets/images/Options/layout.svg',
        action: 'setActiveSetting',
        settingTitle: 'Container Ratio',
    }
];